/**
 * ProcessHeaderPageButtons Handler для HeaderPage
 * 
 * Обробляє кнопки HeaderPage: викликає onButtons event та додає ButtonGroup до extra
 */

import React from 'react'
import { ButtonGroup } from '@/Core/UI/ButtonGroup'

/**
 * Обробляє кнопки HeaderPage
 * 
 * @param params - параметри з headerPageContext
 */
export const ProcessHeaderPageButtons = ({ headerPageContext }: any) => {
    // Отримуємо crudContext з headerPageContext якщо він є
    const crudContext = headerPageContext?.storages?.crudContext
    
    // Перевіряємо чи не вимкнено кнопки
    if (headerPageContext?.settings?.isDisableButtons === true) return

    // Перевіряємо чи вже був доданий ButtonGroup (щоб уникнути дублювання)
    if (headerPageContext?.storages?._buttonsProcessed === true) return

    // Встановлюємо прапорець що кнопки вже оброблені
    headerPageContext.storages ??= {}
    headerPageContext.storages._buttonsProcessed = true

    // Ініціалізуємо порожній об'єкт для кнопок
    let buttons = headerPageContext?.storages?.buttons ?? {}

    // Створюємо масив для додаткового контенту
    const content: any[] = []

    // Викликаємо onButtons event через EventManager
    const eventManager = headerPageContext.getEventManager()
    if (eventManager) {
        eventManager.emit('onButtons', { buttons, headerPageContext, crudContext, content })
    }

    // Якщо є кнопки, додаємо ButtonGroup до extra
    if (Object.keys(buttons).length > 0) {
        headerPageContext.extra ??= []
        headerPageContext.extra.push(
            React.createElement(ButtonGroup, {
                buttons,
                key: 'header-page-group-buttons',
            })
        )
    }
}
